module.exports = __webpack_public_path__ + "static/img/mindMap.4adeb9e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mindMap.jpg
// module id = Hv8l
// module chunks = 1